import React, { useEffect } from 'react';

const portfolioImages = [
  { id: 1, path: 'assets/img/other/portfolio1.webp', alt: 'Portfolio 1' },
  { id: 2, path: 'assets/img/other/portfolio2.webp', alt: 'Portfolio 2' },
  { id: 3, path: 'assets/img/other/portfolio3.webp', alt: 'Portfolio 3' },
  { id: 4, path: 'assets/img/other/portfolio1.webp', alt: 'Portfolio 4' },
  { id: 5, path: 'assets/img/other/portfolio5.webp', alt: 'Portfolio 5' },
  { id: 6, path: 'assets/img/other/portfolio6.webp', alt: 'Portfolio 6' },
  { id: 7, path: 'assets/img/other/portfolio3.webp', alt: 'Portfolio 7' },
  { id: 8, path: 'assets/img/other/portfolio2.webp', alt: 'Portfolio 8' },
  { id: 9, path: 'assets/img/other/portfolio4.webp', alt: 'Portfolio 9' },
];
const Portfolio = () => {
  useEffect(() => {
    // Initialize lightbox or other JavaScript functionality if needed
    const initLightbox = () => {
      const lightboxScript = document.createElement('script');
      lightboxScript.src = "https://cdn.jsdelivr.net/npm/glightbox@3.2.0/dist/js/glightbox.min.js";
      lightboxScript.async = true;
      lightboxScript.onload = () => {
        window.GLightbox?.({
          selector: '.glightbox',
          loop: true,
        });
      };
      document.body.appendChild(lightboxScript);
    };

    initLightbox();
  }, []);

  return (
    <>
      <main className="main__content_wrapper">
        {/* Breadcrumb Section */}
        <section className="breadcrumb__section breadcrumb__bg">
          <div className="container">
            <div className="row row-cols-1">
              <div className="col">
                <div className="breadcrumb__content">
                  <h1 className="breadcrumb__content--title text-white mb-10">Portfolio</h1>
                  <ul className="breadcrumb__content--menu d-flex">
                    <li className="breadcrumb__content--menu__items">
                      <a className="text-white" href="/">Home</a>
                    </li>
                    <li className="breadcrumb__content--menu__items">
                      <span className="text-white">Portfolio</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Portfolio Section */}
        <section className="portfolio__section section--padding">
          <div className="container">
            <div className="section__heading text-center mb-40">
              <h2 className="section__heading--maintitle">Watch Our Portfolio</h2>
            </div>
            <div className="portfolio__section--inner">
              <div className="row row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-2 mb--n30">
              {portfolioImages.map(({id, path, alt}) => (
                  <div className="col mb-30" key={id}>
                    <div className="portfolio__items">
                      <div className="portfolio__items--thumbnail position__relative">
                        <a
                          className="portfolio__items--thumbnail__link glightbox"
                          href={path}
                          data-gallery="portfolio"
                        >
                          <img
                            className="portfolio__items--thumbnail__img"
                            src={path}
                            alt={alt}
                          />
                          <span className="portfolio__view--icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="39.697"
                              height="27.066"
                              viewBox="0 0 39.697 27.066"
                            >
                              <path
                                d="M20.849,4.5A21.341,21.341,0,0,0,1,18.033a21.322,21.322,0,0,0,39.7,0A21.341,21.341,0,0,0,20.849,4.5Zm0,22.555a9.022,9.022,0,1,1,9.022-9.022A9.025,9.025,0,0,1,20.849,27.055Zm0-14.435a5.413,5.413,0,1,0,5.413,5.413A5.406,5.406,0,0,0,20.849,12.62Z"
                                transform="translate(-1 -4.5)"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="newsletter__banner--section section--padding pt-0">
          <div className="container">
            <div className="newsletter__banner--thumbnail position__relative">
              <img
                className="newsletter__banner--thumbnail__img"
                src="assets/img/banner/banner-bg7.webp"
                alt="newsletter-banner"
              />
              <div className="newsletter__content newsletter__subscribe">
                <h5 className="newsletter__content--subtitle text-white">
                  Want to offer regularly?
                </h5>
                <h2 className="newsletter__content--title text-white h3 mb-25">
                  Subscribe Our Newsletter <br />
                  for Get Daily Update
                </h2>
                <form
                  className="newsletter__subscribe--form position__relative"
                  action="#"
                >
                  <label>
                    <input
                      className="newsletter__subscribe--input"
                      placeholder="Enter your email address"
                      type="email"
                    />
                  </label>
                  <button className="newsletter__subscribe--button primary__btn" type="submit">
                    Subscribe
                    <svg
                      className="newsletter__subscribe--button__icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="9.159"
                      height="7.85"
                      viewBox="0 0 9.159 7.85"
                    >
                      <path
                        data-name="Icon material-send"
                        d="M3,12.35l9.154-3.925L3,4.5,3,7.553l6.542.872L3,9.3Z"
                        transform="translate(-3 -4.5)"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Portfolio;
